import { z } from 'zod';

export const pricingParametersSchema = z.object({
  cash: z.object({
    min: z.number(),
    max: z.number(),
    value: z.number(),
  }),
  points: z.object({
    min: z.number(),
    max: z.number(),
    value: z.number(), // total points value from NN
  }),
});

export const giftCardDeliveryMethodSchema = z.union([
  z.literal('email_and_sms'),
  z.literal('email_or_sms'),
  z.literal('email'),
  z.literal('sms'),
  // HYUNDAI new delivery type
  z.literal('mms'),
  // ANZ new delivery type
  z.literal('shipment'),
]);

export const displayTypeSchema = z.union([
  z.literal('all'),
  z.literal('physical'),
  z.literal('digital'),
]);

export const giftCardRedemptionChannelSchema = z.union([
  z.literal('redeem_online'),
  z.literal('redeem_at_store'),
  z.literal('self_redemption'),
  z.literal('direct_redemption'),
  z.literal('redeem_online_and_instore'),
]);

export const giftCardCategorySchema = z.union([
  z.literal('all'),
  z.literal('beauty'),
  z.literal('dining'),
  z.literal('others'),
  z.literal('retail'),
  // ANZ new categories
  z.literal('travel'),
  // Hyundai new categories
  z.literal('department_store'),
  z.literal('hotel'),
  z.literal('hotel_membership'),
]);

export const denominationSchema = z.object({
  id: z.string(),
  displayType: displayTypeSchema,
  displayValue: z.number(),
  maxQuantity: z.number().optional(),
  price: z.number(),
  pricingParameters: pricingParametersSchema,
  validityInDays: z.number(),
});

export const giftCardModelSchema = z.object({
  id: z.string(),
  type: z.literal('gift_card'),
  attributes: z.object({
    name: z.string(),
    categories: z.array(giftCardCategorySchema),
    imageUrls: z.array(z.string()),
    logoUrl: z.string().url().optional(),
    denominations: z.array(denominationSchema),
    displayTypes: z.array(displayTypeSchema),
    maxDiscountPercentage: z.number(),
    shortDescription: z.string().nullable(),
  }),
});

export const giftCardDetailModelSchema = z.object({
  id: z.string(),
  type: z.literal('gift_card'),
  attributes: z.object({
    name: z.string(),
    categories: z.array(giftCardCategorySchema),
    imageUrls: z.array(z.string()),
    logoUrl: z.string().url().optional(),
    denominations: z.array(denominationSchema),
    displayTypes: z.array(displayTypeSchema),
    maxDiscountPercentage: z.number(),
    shortDescription: z.string().nullable(),
    deliveryMethod: giftCardDeliveryMethodSchema,
    description: z.string(),
    redemptionChannel: giftCardRedemptionChannelSchema,
    redemptionInstructions: z.array(z.string()),
    termsAndConditions: z.string().nullable().optional(),
    termsAndConditionsUrl: z.string().url().nullable().optional(),
    validityInDays: z.number(),
  }),
});

export const giftCardResponseSchema = z.object({
  data: z.array(giftCardModelSchema),
});

export const giftCardShowResponseSchema = z.object({
  data: giftCardDetailModelSchema,
});
